import { render, staticRenderFns } from "./DeliveryBookingManual.vue?vue&type=template&id=7f0dd486&scoped=true"
import script from "./DeliveryBookingManual.vue?vue&type=script&lang=js"
export * from "./DeliveryBookingManual.vue?vue&type=script&lang=js"
import style0 from "./DeliveryBookingManual.vue?vue&type=style&index=0&id=7f0dd486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0dd486",
  null
  
)

export default component.exports